import React from 'react'
import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/outline'
import Link from 'gatsby-link'
import resolveLink from '../../utils/resolveLink'
import {TextColour} from '../../utils/ColourUtilities'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
const SubmenuAccordion = (props) => {
    return (
    <div className="w-full lg:hidden block">
        <dl v-for="item in items" className="mt-1 space-y-1">
            <Disclosure as="div" className="">
                {({ open }) => (
                <>
                    <dt className="text-lg">
                    <Disclosure.Button className="group text-left w-full flex justify-between items-center border-b border-gray-200 pb-2">
                        <h5 className={`font-body text-xs ${TextColour(props.accent_colour)}`}>{props.title_3}</h5>
                        <span className="ml-6 h-7 flex items-center">
                        <ChevronDownIcon
                            className={classNames(open ? '-rotate-180' : 'rotate-0', 'text-darkgrey h-6 w-6 transform transition-all duration-500 ease-in-out')}
                            aria-hidden="true"
                        />
                        </span>
                    </Disclosure.Button>
                    </dt>
                    <dd className="mt-2 overflow-hidden">
                        <div style={{ maxHeight: open ? props.submenu_links.length*40 : 0 }} className={'overflow-hidden transform transition-all duration-500 ease-in-out'}>
                            <div className="font-body text-sm leading-6">
                                {props.submenu_links.length > 0 && props.submenu_links.map((item, index) => (
                                    <Link to={resolveLink(`/${item.target.cached_url}`)} key={index} className={`block font-display py-3 leading-3 lg:text-lg text-xl text-darkgrey focus:outline-none outline-none duration-300`}>{item.title}</Link>
                                ))}
                            </div>
                        </div>
                    </dd>
                </>
                )}
            </Disclosure>
        </dl>
    </div>
  )
};

export default SubmenuAccordion;